import ajaxRequest from './ajaxRequest'
import states from '../../assets/states.json'

export async function reverseGeocode(geoPosition, authenticityToken, signal) {
  if (!geoPosition || !geoPosition.coords) return null

  const latitude = geoPosition.coords.latitude
  const longitude = geoPosition.coords.longitude

  // TODO replace the dynamic lookup with a static table, US States don't move
  const response = await ajaxRequest(
    'GET',
    `/reverse_geocode?latitude=${latitude}&longitude=${longitude}`,
    {
      headers: [{'X-CSRF-Token': authenticityToken}],
      json: true,
      signal,
    },
  )

  return (
    states.find(
      (regionState) =>
        regionState.name.toLowerCase() === response.body.state.toLowerCase(),
    ) ?? null
  )
}
